import * as api from '../api'
import { Dispatch } from "@reduxjs/toolkit";
import { endLoading, setAdmins, setAdminsSearch, setDeleteAdmin, setSingleAdmin, setUpdateAdmin, startLoading } from "../reducers/adminsSlice";

export const actionCreateAdmin = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const {data} = await api.createAdmin({postData});
        dispatch({
            type: setAdmins.type,
            payload: data
        })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchAdmins = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchAdmins({page})
        dispatch({
            type: setAdmins.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchAdminsBySearch = ({searchQuery, page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchAdminsBySearch({searchQuery, page})
        dispatch({
            type: setAdminsSearch.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchAdmin = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchAdmin({id})
        dispatch({
            type: setSingleAdmin.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdateAdmin = ({id, postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.updateAdmin({id, postData})
        dispatch({
            type: setUpdateAdmin.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionResendVerification = ({emailAddress}: api.ApiParams) => async() => {
    try{
        const response = await api.resendAdminVerification({emailAddress})
        return response
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionVerifyAdminRegEmail = ( {id, emailAddress, otp}: api.ApiParams ) => async() => {
    try{
        const {data} = await api.verifyAdminRegEmail({id, emailAddress, otp})
        return data;
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionVerifyEmailPassword = ({emailAddress}: api.ApiParams) => async() => {
    try{
        const response = await api.verifyAdminEmailPassword({emailAddress})
        return response
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionUpdatePassword = ({id, postData}: api.ApiParams) => async() => {
    try{
        const response = await api.passwordResetAdmin({id, postData})
        return response;
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionDeleteAdmin = ({id}: api.ApiParams) => async (dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const data = await api.deleteAdmin(id)
        dispatch({
            type: setDeleteAdmin.type,
            payload: id
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}